// Bootstrap environment

window.Promise = require('../common/configureBluebird');
require('./main');
